import React, { useState, useEffect } from "react";
import { Link, useHistory, Redirect } from "react-router-dom";

import {
  makeStyles,
  Grid,
  Container,
  Paper,
  Typography,
  Button,
} from "@material-ui/core";

import { getNFTContractCount, getNFTShareToken } from "./NFTFunctions";
import NFTPoolsItem from "./NFTPoolsItem";

const useStyles = makeStyles((theme) => ({
  howItWorks: {
    color: "inherit",
    textDecoration: "none",
    "&:hover": {
      color: `${theme.palette.primary.main} !important`,
    },
  },

  paperContainer: {
    borderRadius: theme.spacing(2),
    width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

function NFTPools({ network }) {
  const history = useHistory();
  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);

  const get_nfts = async () => {
    // start loading
    setLoading(true);

    let total_nft = await getNFTContractCount(
      network.nftSharing,
      network.signer
    );

    if (total_nft <= 0) {
      // no pool
      setLoading(false);
    } else {
      let nftList = [];
      for (let i = 0; i < total_nft; i++) {
        const index = i;
        await getNFTShareToken(network.nftSharing, network.signer, index).then(
          (res) => {
            nftList.push(res);
          }
        );
      }

      setLoading(false);
      setList(nftList);
    }
  };

  useEffect(() => {
    const myNFTTimeout = setTimeout(() => {
      if (network.nftSharing) {
        get_nfts();
      }
    }, 1000);
    return () => clearTimeout(myNFTTimeout);
  }, []);

  return (
    <>
      {network.chainID != 56 ? (
        <div id="nft-pools">
          <Container maxWidth="xl">
            <Grid container className="mb-4 align-items-center" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="h6">NFT Pools</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                className="d-flex flex-wrap align-items-center justify-content-start justify-content-sm-end gap-2"
              >
                <Link to="/swap" className={classes.howItWorks}>
                  <Typography variant="body1">How it works?</Typography>
                </Link>

                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => history.push("/my-nfts")}
                >
                  Start trade my NFT
                </Button>
              </Grid>
            </Grid>

            {(!list.length || loading) && (
              <Grid container>
                <Paper elevation={0} className={classes.paperContainer}>
                  {loading ? "Loading..." : "No Pool To Show"}
                </Paper>
              </Grid>
            )}

            {list.map((item, index) => (
              <NFTPoolsItem
                key={`${item}_${index}`}
                item={item}
                network={network}
              />
            ))}
          </Container>
        </div>
      ) : (
        <Redirect to="/invest" />
      )}
    </>
  );
}

export default NFTPools;
